/**
 * Avatars d'un INVITÉ (session anonyme) — migration 0260.
 *
 * Un invité n'a pas de profil ni de droit d'upload (écritures storage
 * refusées aux sessions anonymes, migration 0258) : il choisit un avatar dans
 * une liste FERMÉE. Seule la CLÉ est stockée (`video_room_participants.
 * avatar_preset`, le temps de la réunion) ; l'image est une data URI SVG
 * construite côté serveur par `public.visio_guest_avatar_url(preset)`, jamais
 * une URL fournie par le client (sinon un invité pourrait charger une image
 * externe — pixel de traçage — chez les autres participants).
 *
 * ⚠️ MIROIR : les littéraux SQL de `visio_guest_avatar_url` (0260) doivent
 * être EXACTEMENT `guestAvatarUrl(key)` — vérifié par `guest-avatars.test.ts`.
 */

export interface GuestAvatarPreset {
  key: string;
  emoji: string;
  /** Couleur de fond, hex SANS `#` (encodé `%23` dans la data URI). */
  bg: string;
  label: string;
}

export const GUEST_AVATAR_PRESETS: readonly GuestAvatarPreset[] = [
  { key: 'renard', emoji: '🦊', bg: 'FFE3C2', label: 'Renard' },
  { key: 'chouette', emoji: '🦉', bg: 'EADBC8', label: 'Chouette' },
  { key: 'panda', emoji: '🐼', bg: 'E5E7EB', label: 'Panda' },
  { key: 'chat', emoji: '🐱', bg: 'FDE68A', label: 'Chat' },
  { key: 'lion', emoji: '🦁', bg: 'FCD9A8', label: 'Lion' },
  { key: 'pieuvre', emoji: '🐙', bg: 'FBCFE8', label: 'Pieuvre' },
  { key: 'tortue', emoji: '🐢', bg: 'BBF7D0', label: 'Tortue' },
  { key: 'licorne', emoji: '🦄', bg: 'DDD6FE', label: 'Licorne' },
] as const;

export const DEFAULT_GUEST_AVATAR = 'renard';

/** Data URI SVG d'un preset (même chaîne que le serveur) ; `null` si clé inconnue. */
export function guestAvatarUrl(key: string | null | undefined): string | null {
  const p = GUEST_AVATAR_PRESETS.find((a) => a.key === key);
  if (!p) return null;
  return (
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>" +
    `<rect width='64' height='64' fill='%23${p.bg}'/>` +
    `<text x='32' y='44' font-size='36' text-anchor='middle'>${p.emoji}</text></svg>`
  );
}
